enum Language
{
    English = 1,
    German = 2,
    French = 3,
    Italian = 4
}

export default Language;